import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";
import { FadeUp, SectionHeading } from "@/components/Reveal";
import { MARKETING_TABS } from "@/data/site";

const Marketing = () => {
  const [active, setActive] = useState(MARKETING_TABS[0].id);
  const tab = MARKETING_TABS.find((t) => t.id === active);

  return (
    <section id="marketing" className="border-y border-white/10 bg-[#0C0C0F]" data-testid="marketing-section">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-12 lg:py-32">
        <SectionHeading
          eyebrow="Digital marketing"
          title="Attention in. Revenue out."
          sub="Four disciplines, one goal: measurable growth. Pick a channel to see how we run it."
        />
        <FadeUp className="mt-12">
          <div className="flex flex-wrap gap-2" role="tablist">
            {MARKETING_TABS.map((t) => (
              <button
                key={t.id}
                role="tab"
                aria-selected={active === t.id}
                onClick={() => setActive(t.id)}
                data-testid={`marketing-tab-${t.id}`}
                className={`mono rounded-full px-5 py-2.5 text-xs uppercase tracking-[0.15em] transition-all duration-300 ${
                  active === t.id
                    ? "bg-[#D9A92E] text-[#09090B] shadow-[0_0_20px_rgba(217,169,46,0.4)]"
                    : "border border-white/10 text-[#A1A1AA] hover:border-[#D9A92E]/40 hover:text-white"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
          <div className="mt-8 overflow-hidden rounded-2xl border border-white/10 bg-[#131316]">
            <AnimatePresence mode="wait">
              <motion.div
                key={tab.id}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -16 }}
                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                className="grid gap-10 p-8 lg:grid-cols-[1fr_260px] lg:p-12"
                data-testid={`marketing-panel-${tab.id}`}
              >
                <div>
                  <h3 className="font-display text-xl font-bold text-white sm:text-2xl">{tab.title}</h3>
                  <p className="mt-4 max-w-xl text-base leading-relaxed text-[#A1A1AA]">
                    {tab.description}
                  </p>
                  <ul className="mt-7 space-y-3">
                    {tab.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 text-sm text-[#A1A1AA]">
                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#D9A92E]/12">
                          <Check className="h-3 w-3 text-[#D9A92E]" />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex flex-col justify-center rounded-xl border border-[#D9A92E]/20 bg-[#D9A92E]/5 p-8 text-center">
                  <div className="font-display text-5xl font-extrabold text-[#D9A92E]">{tab.stat}</div>
                  <div className="mono mt-3 text-[10px] uppercase leading-relaxed tracking-[0.2em] text-[#A1A1AA]">
                    {tab.statLabel}
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default Marketing;
